import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Events } from '../types';
import { filter, map } from 'rxjs/operators';

interface Event<T> {
  name: Events;
  payload: T;
}

const nullEvent: Event<void> = {
  name: null,
  payload: undefined,
};

@Injectable({
  providedIn: 'root',
})
export class EventBusService {
  private subject$ = new BehaviorSubject<Event<any>>(nullEvent);

  on<T>(event: Events): Observable<T> {
    return this.subject$.pipe(
      filter((e: Event<T>) => e.name === event),
      map((e: Event<T>) => e.payload),
    );
  }

  emit<T>(name: Events, payload?: T): void {
    this.subject$.next({
      name,
      payload,
    } as Event<T>);
  }
}
